<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :table-filter="{label:''}"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="item"
                :fields="fields"
                :items-per-page="small ? 50 : 20"
                :dark="dark"
                pagination
            >
              <template #index="{item,index}">
                <td class="text-center"> {{ index + 1 }}</td>
              </template>

<!--              <template #avata="{item,index}">-->
<!--                <td>-->
<!--                  <div class="c-avatar">-->
<!--                    <img :src="item.userinfo.image" class="c-avatar-img" alt="" @error="errorImage">-->
<!--                    <span-->
<!--                        class="c-avatar-status"-->
<!--                        :class="`bg-success`"-->
<!--                    ></span>-->
<!--                  </div>-->
<!--                </td>-->
<!--              </template>-->

              <template #members="{item,index}"  >
                <td  @click="toggleDetails(item, index)">
                  <p class="mb-0"> {{ item.authen.filter(obj => { return (obj.type == "66a06852660ccb1debade7c5")})[0].username }}</p>
                  <p class="mb-0" style="white-space: nowrap;">{{ item.userinfo.prefix.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.firstName.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.lastName.filter(item => { return (item.key == lang ) })[0].value }}</p>
                </td>
              </template>


<!--              <template #info="{item,index}">-->
<!--                <td>-->
<!--                  <p class="mb-0"> E-mail : {{ item.authen.filter(item => { return (item.email != null ) })[0].email }} </p>-->
<!--                  <p class="mb-0"> Mobile : {{ item.userinfo.msisdn }} </p>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #attend="{item,index}">-->
<!--                <td class="text-center"> {{ item.historys.length }} / {{ max }}</td>-->
<!--              </template>-->


<!--              <template #calss="{item,index}">-->
<!--                <td>-->
<!--&lt;!&ndash;                  <p class="mb-0"> <span class="font-weight-bold">Code : </span> {{ (item.historys.length >0)?item.historys[0].code:"" }} </p>&ndash;&gt;-->
<!--                  <p class="mb-0" style="white-space: nowrap;"> <span class="font-weight-bold">Title : </span>{{  (item.historys.length >0)?item.historys[0].title:"" }}</p>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #dateTime="{item,index}">-->
<!--                <td>-->
<!--&lt;!&ndash;                  <p class="mb-0 text-right"> <span class="font-weight-bold">Online :</span> 30 min</p>&ndash;&gt;-->
<!--                  <p class="mb-0 text-right"> <span class="font-weight-bold"></span> {{  new moment().format("DD MMMM YYYY HH:mm:ss") }}</p>-->
<!--                </td>-->
<!--              </template>-->

<!--              <template #action="{item}">-->
<!--                <td style="width: 140px">-->
<!--                  <CRow>-->
<!--                    <CCol class="text-center">-->
<!--                      <CButton class="mr-1" v-c-tooltip.hover.click="'Studens'" size="sm" color="success" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >-->
<!--                        <CIcon name="cil-people"/>-->
<!--                      </CButton>-->

<!--                    </CCol>-->
<!--                  </CRow>-->
<!--                </td>-->
<!--              </template>-->



              <template #details="{item}">
                <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
                  <CCardBody>
                    <CDataTable
                        table-filter
                        :items="item.historys"
                        items-per-page-select
                        :items-per-page="20"
                        hover
                        sorter
                        pagination
                    >

                    </CDataTable>
                  </CCardBody>
                </CCollapse>
              </template>


            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'History',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:80px; text-align: center'},
          // {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          // {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"info", label:"Info",},
          // {key:"dateTime", label:"Last Update",  _style: 'width:190px; text-align: center'},
          // {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,


    item: {
      type: Array,
      default() {
        return []
      }
    },
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,
      method: [],




      max : 10,
      items: [
        {
          code: "6331201001",
          prefix: "MISS",
          firstName: "KODCHAKORN",
          lastName: "PANYANIL",
          src:"https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
          section: 1,
          historys : [
            { code: "1001115", title : "Arts of Speech", in:"05/08/2024 15:51", out:"05/08/2024 15:56"  },
            { code: "1001115", title : "Arts of Speech", in:"05/08/2024 15:51", out:"05/08/2024 15:56"  },
            { code: "1001115", title : "Arts of Speech", in:"05/08/2024 15:51", out:"05/08/2024 15:56"  },
            { code: "1001115", title : "Arts of Speech", in:"05/08/2024 15:51", out:"05/08/2024 15:56"  },
            { code: "1001115", title : "Arts of Speech", in:"05/08/2024 15:51", out:"05/08/2024 15:56"  }
          ]
        },
        {
          code: "6331201002",
          prefix: "MISS",
          firstName: "KANOKON",
          lastName: "PHOSRI",
          src:"https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
          section: 1,
          historys : []
        },
        {
          code: "6331201003",
          prefix: "MR.",
          firstName: "CHAKKRACHAI",
          lastName: "PONGPANICH",
          src:"https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
          section: 1,
          historys : []
        },
        {
          code: "6331201006",
          prefix: "MISS",
          firstName: "JULALAK",
          lastName: "CHOTNUKUL",
          src:"https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
          section: 1,
          historys : []
        }
      ]


    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    errorImage(e) {
      e.target.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    }


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
